export const Styles = {
  footer: (footerWidth: string | number) => ({
    position: "fixed" as const,
    right: "0px",
    left: "250px",
    bottom: "0px",
    zIndex: 998,
    transition: "left 0.3s ease",
  }),
  filePicker: {
    root: {
      ".ms-TextField-fieldGroup": {
        "border": "none",
        ":active, :hover, :focus": {
          border: "none",
        },
      },
      "input[type=file]::file-selector-button": {
        border: "1px solid var(--color-fg-4)",
        padding: ".2em .4em",
        borderRadius: ".2em",
        height: "31px",
        color: "var(--color-fg-1)",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "20px",
        backgroundColor: "var(--color-surface)",
        transition: "1s",
      },
    },
  },

  main: {
    position: "fixed" as const,
    top: "0",
    bottom: "0",
    left: "0",
    right: "0",
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: "99999",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transformOrigin: "center !important",
  },

  feedbackParent: {
    root: {
      position: "absolute" as const,
      right: "0%",
      bottom: "100%",
    },
  },

  feedbackButton: {
    root: {
      cursor: "pointer",
      color: "var(--color-accent-foreground)",
      backgroundColor: "var(--color-fg-1)",
      border: "1px solid #000000",
      textAlign: "center",
      padding: "0px 16px 0px 16px",
    },
    rootHovered: {
      backgroundColor: "var(--color-fg-1)",
      color: "var(--color-accent-foreground)",
      border: "1px solid #000000",
    },
    iconHovered: {
      color: "var(--color-accent-foreground)",
    },
  },

  chatSGPTButton: {
    root: {
      cursor: "pointer",
      color: "var(--color-accent-foreground)",
      textAlign: "center",
      backgroundColor: "var(--color-fg-1)",
      padding: "0px 16px 0px 16px",
    },
    rootHovered: {
      backgroundColor: "var(--color-fg-1)",
      color: "var(--color-accent-foreground)",
    },
    iconHovered: {
      color: "var(--color-accent-foreground)",
    },
  },

  needHelpButton: {
    root: {
      cursor: "pointer",
      color: "var(--color-accent-foreground)",
      backgroundColor: "rgb(247, 138, 5)",
      border: "1px solid rgb(247, 138, 5)",
      textAlign: "center",
      padding: "0px 16px 0px 16px",
    },
  },

  modalContent: {
    backgroundColor: "var(--color-surface)",
    textAlign: "center" as const,
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: " 23px",
    color: "var(--color-fg-1)",
    margin: "0px",
    marginTop: "20px",
    height: "326px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column" as const,
    transformOrigin: "center !important",
  },

  modalHeader: {
    fontFamily: "inherit",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "20px",
    letterSpacing: "0px",
    textAlign: "left" as const,
  },

  modalBody: {
    textAlign: "center" as const,
    display: "flex",
    padding: "10px 0px 10px 0px",
  },

  feedbackFormButton: {
    "root": {
      "width": "240px",
      "height": "51px",
      "cursor": "pointer",
      "backgroundColor": "#7F7F7F",
      "color": "var(--color-accent-foreground)",
      "marginBottom": "10px",
      "textAlign": "left",
      ".modal-content": {
        width: "100%",
        margiTop: "13%",
      },
      ".ms-Button:hover": {
        "backgroundColor": "var(--color-brand-70)",
        "color": "var(--color-accent-foreground)",
        ".ms-Button-icon": {
          color: "var(--color-accent-foreground)",
        },
        ".ms-Button-icon:hover": {
          color: "var(--color-accent-foreground)",
        },
      },
      "&:hover": {
        color: "inherit",
        textDecoration: "inherit",
      },
      ".ms-Button--commandBar:hover": {
        backgroundColor: "var(--color-brand-70)",
        color: "var(--color-accent-foreground)",
      },
    },
    ".ms-Button:hover": {
      backgroundColor: "var(--color-brand-70)",
      color: "var(--color-accent-foreground)",
    },
    ".ms-Button--commandBar:hover": {
      backgroundColor: "var(--color-brand-70)",
      color: "var(--color-accent-foreground)",
    },
    ".ms-Button .ms-Button--commandBar:hover": {
      backgroundColor: "var(--color-brand-70)",
      color: "var(--color-accent-foreground)",
    },
  },

  primaryBtnModal: {
    root: {
      backgroundColor: "var(--color-brand-70)",
      border: "1px solid var(--color-brand-70)",
      float: "right",
      marginLeft: "20px",
    },
    rootPressed: {
      backgroundColor: "var(--color-brand-70)",
      border: "1px solid var(--color-brand-70)",
    },
    rootHovered: {
      backgroundColor: "var(--color-brand-70)",
      border: "1px solid var(--color-brand-70)",
    },
  },

  feedbackDiv: {
    position: "fixed" as const,
    bottom: "0px",
    right: "20px",
    zIndex: "1",
  },

  feedbackForm: {
    transition: "2s ease-out",
    marginLeft: "15px",
    borderLeft: "1px solid var(--color-stroke-subtle)",
    paddingLeft: "26px",
  },

  fadeInStyles: {
    root: {
      animation: "fadeIn 0.367s cubic-bezier(0.1, 0.9, 0.2, 1)",
      animationDuration: "0.3s",
    },
  },
  slideLeftInStyles: {
    root: {
      minWidth: "320px",
      animation: "slideLeftIn 0.367s cubic-bezier(0.1, 0.25, 0.75, 0.9)",
      animationDuration: "2.5s",
      marginLeft: "15px",
      borderLeft: "1px solid var(--color-stroke-subtle)",
      paddingLeft: "26px",
    },
  },

  comment: {
    root: {
      paddingBottom: "10px",
    },
  },

  email: {
    root: {
      marginBottom: "32px",
    },
  },

  checkbox: {
    label: {
      fontSize: "14px",
      whiteSpace: "nowrap",
    },
    checkmark: {
      backgroundColor: "var(--color-brand-70)",
      borderColor: "var(--color-brand-70) !important",
      width: "100%",
    },
  },
  submitButtonDiv: {
    root: {
      textAlign: "right",
      width: "100%",
    },
  },
};
